export default {
    'name': 'breadcrumbs-1',
    'width': '12',
    'height': '18',
    'viewBox': '0 0 18 12',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M17.7586 6C17.7586 6.27614 17.5348 6.5 17.2586 6.5L0.5 6.5C0.223858 6.5 -1.23071e-08 6.27614 0 6C1.23071e-08 5.72386 0.223858 5.5 0.5 5.5L17.2586 5.5C17.5348 5.5 17.7586 5.72386 17.7586 6Z\' fill=\'#026958\'/>'
}
